import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2, AlertTriangle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const { api } = useAuth();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const verify = async () => {
      const email = searchParams.get('email') || '';
      const token = searchParams.get('token') || '';

      if (!email || !token) {
        setStatus('error');
        setMessage('Invalid verification link. Please request a new link.');
        return;
      }

      try {
        const res = await api.post('/api/auth/verify-email', { email, token });
        setStatus('success');
        setMessage(res.data?.message || 'Email verified successfully.');
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Failed to verify email.');
      }
    };

    verify();
  }, [api, searchParams]);

  return (
    <div className="min-h-screen bg-slate-100 px-4 py-16">
      <div className="mx-auto max-w-lg rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        {status === 'loading' && (
          <div className="text-center">
            <Loader2 className="mx-auto h-10 w-10 animate-spin text-emerald-600" />
            <h1 className="mt-4 text-2xl font-bold text-slate-900">Verifying Email</h1>
            <p className="mt-2 text-slate-600">{message}</p>
          </div>
        )}

        {status === 'success' && (
          <div className="text-center">
            <CheckCircle2 className="mx-auto h-11 w-11 text-emerald-600" />
            <h1 className="mt-4 text-2xl font-bold text-slate-900">Email Verified</h1>
            <p className="mt-2 text-slate-600">{message}</p>
            <Link
              to="/login"
              className="mt-6 inline-flex items-center justify-center rounded-xl bg-emerald-600 px-5 py-2.5 font-semibold text-white hover:bg-emerald-700"
            >
              Go to Login
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="text-center">
            <AlertTriangle className="mx-auto h-11 w-11 text-amber-600" />
            <h1 className="mt-4 text-2xl font-bold text-slate-900">Verification Failed</h1>
            <p className="mt-2 text-slate-600">{message}</p>
            <Link
              to="/login"
              className="mt-6 inline-flex items-center justify-center rounded-xl border border-slate-300 px-5 py-2.5 font-semibold text-slate-700 hover:bg-slate-50"
            >
              Back to Login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
